import React from "react";
import { useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";

const StyledButtonImage = styled.img`
  position: absolute;
  padding: 8px;
  width: 50px;
  ${({ standAlone }) =>
    standAlone &&
    css`
      z-index: 1000;
      top: 20px;
      left: 10px;
    `}
`;

const BackButton = ({ src, standAlone = false }) => {
  const navigate = useNavigate();

  const handleNavigateBack = () => {
    navigate(-1);
  };
  return (
    <StyledButtonImage
      src={src}
      standAlone={standAlone}
      onClick={handleNavigateBack}
    />
  );
};

export default BackButton;
